export default __webpack_public_path__ + "static/media/key.dbb66f6f.webp";